import objectPath from 'object-path';
import { action, observable } from 'mobx';
import { getLanguageOptions, getCanonicalLanguage } from 'core/i18n';
import { i18n } from 'config/i18n';
import Alert from 'react-s-alert';

import { AppManager, App, Input, Variables } from 'core';

import { FormStore } from 'libs/forms/app';

import { clientStore } from 'apps/client/app';
import { ProfileApp } from 'apps/profile/app';
import {
  ChangeLanguagePreferencesMutation,
  LanguagePreferencesQuery,
} from 'apps/profile/gql';
import { conf } from 'apps/profile/settings/config.yaml';

class LanguagePreferencesApp extends App {
  static registryName = 'LanguagePreferencesApp';
  @observable languageSelection = '';
  init() {
    const availableLanguages = i18n.options.supportedLngs.map(code =>
      getCanonicalLanguage(code),
    );

    conf.fields.languageSelection = {
      label: 'Language',
      placeholder: 'Please select',
      component: 'forms.SelectField',
      fieldStore: 'forms.StringFieldStore',
      labelKey: 'text',
      appKey: 'locale',
      options: { values: getLanguageOptions(availableLanguages) },
    };
    this.form = new FormStore(this, conf, 'languagePreferencesForm', '', false);
  }

  @action
  Submit = () => {
    const input = new Input({ locale: this.languageSelection });
    this.manager.Submit(input, {
      onSysErr: this.onError,
      onUserErr: this.onError,
      onSuccess: this.onSuccess,
    });
  };

  @action
  onError = () => {
    Alert.error('Hmm... We failed to change your language. Please try again.');
  };

  @action
  onSuccess = result => {
    if (result.result === 'ok') {
      Alert.success('Language preferences updated successfully!');
      i18n.changeLanguage(this.languageSelection);
    }
  };
}

export class ChangeLanguageAppManager extends AppManager {
  static registryName = 'ChangeLanguageAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('profile', ProfileApp);
    this.variables = new Variables({
      username: () => objectPath.get(clientStore.signedInProfile, 'username'),
    });
    this.app = new LanguagePreferencesApp(this, {});
    this.app.init();
    this.QueryLanguagePreferences();
  }

  @action
  QueryLanguagePreferences = () => {
    const q = new LanguagePreferencesQuery(this, {
      queryKey: 'languagePreferences',
    });
    q.process(
      result => result,
      result => {
        if (result) this.app.languageSelection = result.user.locale;
      },
    );
    q.query();
  };

  @action
  Submit = (input, options) => {
    this.mutations.push(ChangeLanguagePreferencesMutation.New(input, options));
  };
}
